<template>
  <footer class="footer text-center text-muted">
    <div class="text-left text-muted ml-2">Please Note: <br /></div>
    <div class="text-center text-muted">
      That real estate investments involve risks including loss of capital, lack
      of liquidity, default of a borrower and lack of performance. The risks
      involved will vary depending on the type of project, so make sure you have
      read and understood the specific risks associated with the investment.
      Investments made on this website should only be made as part of a
      diversified investment portfolio. Projections or estimated returns are not
      a reliable indicator of actual future performance and any returns or
      dividends may be lower than anticipated. The information presented on this
      website is for guidance only and does not constitute financial advice. If
      you are unsure about the suitability of an investment, contact your
      financial advisor for professional advice.
    </div>
    <br />
    <div class="text-left text-muted">
      © 2020 Vivot Ltd. All rights reserved.
    </div>
  </footer>
</template>
<script>
export default {
  name: 'TheFooter',
  components: {},
};
</script>
